/* AUTO GENERATED CONTENT: DO NOT MODIFY THIS FILE. SEE /TOOLS FOLDER FOR CHANGES */

export const palette = {
  'neutral-dark-2': 'hsl(207, 25%, 11%, 0.02)',
  'neutral-light-2': 'hsl(207, 25%, 85%, 0.02)',
  'purple-dark-2': 'hsl(247, 100%, 62%, 0.02)',
  'purple-light-2': 'hsl(247, 100%, 80%, 0.02)',
  'teal-dark-2': 'hsl(188, 100%, 28%, 0.02)',
  'teal-light-2': 'hsl(188, 35%, 55%, 0.02)',
  'orange-dark-2': 'hsl(20, 100%, 50%, 0.02)',
  'orange-light-2': 'hsl(15, 90%, 65%, 0.02)',
  'red-dark-2': 'hsl(1, 65%, 54%, 0.02)',
  'red-light-2': 'hsl(1, 100%, 70%, 0.02)',
  'yellow-dark-2': 'hsl(35, 100%, 38%, 0.02)',
  'yellow-light-2': 'hsl(35, 100%, 55%, 0.02)',
  'green-dark-2': 'hsl(165, 100%, 26%, 0.02)',
  'green-light-2': 'hsl(165, 100%, 37%, 0.02)',
  'blue-dark-2': 'hsl(207, 100%, 42%, 0.02)',
  'blue-light-2': 'hsl(207, 100%, 58%, 0.02)',
  'white-2': 'hsl(0, 0%, 100%, 0.02)',
  'neutral-dark-4': 'hsl(207, 25%, 11%, 0.04)',
  'neutral-light-4': 'hsl(207, 25%, 85%, 0.04)',
  'purple-dark-4': 'hsl(247, 100%, 62%, 0.04)',
  'purple-light-4': 'hsl(247, 100%, 80%, 0.04)',
  'teal-dark-4': 'hsl(188, 100%, 28%, 0.04)',
  'teal-light-4': 'hsl(188, 35%, 55%, 0.04)',
  'orange-dark-4': 'hsl(20, 100%, 50%, 0.04)',
  'orange-light-4': 'hsl(15, 90%, 65%, 0.04)',
  'red-dark-4': 'hsl(1, 65%, 54%, 0.04)',
  'red-light-4': 'hsl(1, 100%, 70%, 0.04)',
  'yellow-dark-4': 'hsl(35, 100%, 38%, 0.04)',
  'yellow-light-4': 'hsl(35, 100%, 55%, 0.04)',
  'green-dark-4': 'hsl(165, 100%, 26%, 0.04)',
  'green-light-4': 'hsl(165, 100%, 37%, 0.04)',
  'blue-dark-4': 'hsl(207, 100%, 42%, 0.04)',
  'blue-light-4': 'hsl(207, 100%, 58%, 0.04)',
  'white-4': 'hsl(0, 0%, 100%, 0.04)',
  'neutral-dark-8': 'hsl(207, 25%, 11%, 0.08)',
  'neutral-light-8': 'hsl(207, 25%, 85%, 0.08)',
  'purple-dark-8': 'hsl(247, 100%, 62%, 0.08)',
  'purple-light-8': 'hsl(247, 100%, 80%, 0.08)',
  'teal-dark-8': 'hsl(188, 100%, 28%, 0.08)',
  'teal-light-8': 'hsl(188, 35%, 55%, 0.08)',
  'orange-dark-8': 'hsl(20, 100%, 50%, 0.08)',
  'orange-light-8': 'hsl(15, 90%, 65%, 0.08)',
  'red-dark-8': 'hsl(1, 65%, 54%, 0.08)',
  'red-light-8': 'hsl(1, 100%, 70%, 0.08)',
  'yellow-dark-8': 'hsl(35, 100%, 38%, 0.08)',
  'yellow-light-8': 'hsl(35, 100%, 55%, 0.08)',
  'green-dark-8': 'hsl(165, 100%, 26%, 0.08)',
  'green-light-8': 'hsl(165, 100%, 37%, 0.08)',
  'blue-dark-8': 'hsl(207, 100%, 42%, 0.08)',
  'blue-light-8': 'hsl(207, 100%, 58%, 0.08)',
  'white-8': 'hsl(0, 0%, 100%, 0.08)',
  'neutral-dark-12': 'hsl(207, 25%, 11%, 0.12)',
  'neutral-light-12': 'hsl(207, 25%, 85%, 0.12)',
  'purple-dark-12': 'hsl(247, 100%, 62%, 0.12)',
  'purple-light-12': 'hsl(247, 100%, 80%, 0.12)',
  'teal-dark-12': 'hsl(188, 100%, 28%, 0.12)',
  'teal-light-12': 'hsl(188, 35%, 55%, 0.12)',
  'orange-dark-12': 'hsl(20, 100%, 50%, 0.12)',
  'orange-light-12': 'hsl(15, 90%, 65%, 0.12)',
  'red-dark-12': 'hsl(1, 65%, 54%, 0.12)',
  'red-light-12': 'hsl(1, 100%, 70%, 0.12)',
  'yellow-dark-12': 'hsl(35, 100%, 38%, 0.12)',
  'yellow-light-12': 'hsl(35, 100%, 55%, 0.12)',
  'green-dark-12': 'hsl(165, 100%, 26%, 0.12)',
  'green-light-12': 'hsl(165, 100%, 37%, 0.12)',
  'blue-dark-12': 'hsl(207, 100%, 42%, 0.12)',
  'blue-light-12': 'hsl(207, 100%, 58%, 0.12)',
  'white-12': 'hsl(0, 0%, 100%, 0.12)',
  'neutral-dark-16': 'hsl(207, 25%, 11%, 0.16)',
  'neutral-light-16': 'hsl(207, 25%, 85%, 0.16)',
  'purple-dark-16': 'hsl(247, 100%, 62%, 0.16)',
  'purple-light-16': 'hsl(247, 100%, 80%, 0.16)',
  'teal-dark-16': 'hsl(188, 100%, 28%, 0.16)',
  'teal-light-16': 'hsl(188, 35%, 55%, 0.16)',
  'orange-dark-16': 'hsl(20, 100%, 50%, 0.16)',
  'orange-light-16': 'hsl(15, 90%, 65%, 0.16)',
  'red-dark-16': 'hsl(1, 65%, 54%, 0.16)',
  'red-light-16': 'hsl(1, 100%, 70%, 0.16)',
  'yellow-dark-16': 'hsl(35, 100%, 38%, 0.16)',
  'yellow-light-16': 'hsl(35, 100%, 55%, 0.16)',
  'green-dark-16': 'hsl(165, 100%, 26%, 0.16)',
  'green-light-16': 'hsl(165, 100%, 37%, 0.16)',
  'blue-dark-16': 'hsl(207, 100%, 42%, 0.16)',
  'blue-light-16': 'hsl(207, 100%, 58%, 0.16)',
  'white-16': 'hsl(0, 0%, 100%, 0.16)',
  'neutral-dark-20': 'hsl(207, 25%, 11%, 0.2)',
  'neutral-light-20': 'hsl(207, 25%, 85%, 0.2)',
  'purple-dark-20': 'hsl(247, 100%, 62%, 0.2)',
  'purple-light-20': 'hsl(247, 100%, 80%, 0.2)',
  'teal-dark-20': 'hsl(188, 100%, 28%, 0.2)',
  'teal-light-20': 'hsl(188, 35%, 55%, 0.2)',
  'orange-dark-20': 'hsl(20, 100%, 50%, 0.2)',
  'orange-light-20': 'hsl(15, 90%, 65%, 0.2)',
  'red-dark-20': 'hsl(1, 65%, 54%, 0.2)',
  'red-light-20': 'hsl(1, 100%, 70%, 0.2)',
  'yellow-dark-20': 'hsl(35, 100%, 38%, 0.2)',
  'yellow-light-20': 'hsl(35, 100%, 55%, 0.2)',
  'green-dark-20': 'hsl(165, 100%, 26%, 0.2)',
  'green-light-20': 'hsl(165, 100%, 37%, 0.2)',
  'blue-dark-20': 'hsl(207, 100%, 42%, 0.2)',
  'blue-light-20': 'hsl(207, 100%, 58%, 0.2)',
  'white-20': 'hsl(0, 0%, 100%, 0.2)',
  'neutral-dark-24': 'hsl(207, 25%, 11%, 0.24)',
  'neutral-light-24': 'hsl(207, 25%, 85%, 0.24)',
  'purple-dark-24': 'hsl(247, 100%, 62%, 0.24)',
  'purple-light-24': 'hsl(247, 100%, 80%, 0.24)',
  'teal-dark-24': 'hsl(188, 100%, 28%, 0.24)',
  'teal-light-24': 'hsl(188, 35%, 55%, 0.24)',
  'orange-dark-24': 'hsl(20, 100%, 50%, 0.24)',
  'orange-light-24': 'hsl(15, 90%, 65%, 0.24)',
  'red-dark-24': 'hsl(1, 65%, 54%, 0.24)',
  'red-light-24': 'hsl(1, 100%, 70%, 0.24)',
  'yellow-dark-24': 'hsl(35, 100%, 38%, 0.24)',
  'yellow-light-24': 'hsl(35, 100%, 55%, 0.24)',
  'green-dark-24': 'hsl(165, 100%, 26%, 0.24)',
  'green-light-24': 'hsl(165, 100%, 37%, 0.24)',
  'blue-dark-24': 'hsl(207, 100%, 42%, 0.24)',
  'blue-light-24': 'hsl(207, 100%, 58%, 0.24)',
  'white-24': 'hsl(0, 0%, 100%, 0.24)',
  'neutral-dark-32': 'hsl(207, 25%, 11%, 0.32)',
  'neutral-light-32': 'hsl(207, 25%, 85%, 0.32)',
  'purple-dark-32': 'hsl(247, 100%, 62%, 0.32)',
  'purple-light-32': 'hsl(247, 100%, 80%, 0.32)',
  'teal-dark-32': 'hsl(188, 100%, 28%, 0.32)',
  'teal-light-32': 'hsl(188, 35%, 55%, 0.32)',
  'orange-dark-32': 'hsl(20, 100%, 50%, 0.32)',
  'orange-light-32': 'hsl(15, 90%, 65%, 0.32)',
  'red-dark-32': 'hsl(1, 65%, 54%, 0.32)',
  'red-light-32': 'hsl(1, 100%, 70%, 0.32)',
  'yellow-dark-32': 'hsl(35, 100%, 38%, 0.32)',
  'yellow-light-32': 'hsl(35, 100%, 55%, 0.32)',
  'green-dark-32': 'hsl(165, 100%, 26%, 0.32)',
  'green-light-32': 'hsl(165, 100%, 37%, 0.32)',
  'blue-dark-32': 'hsl(207, 100%, 42%, 0.32)',
  'blue-light-32': 'hsl(207, 100%, 58%, 0.32)',
  'white-32': 'hsl(0, 0%, 100%, 0.32)',
  'neutral-dark-40': 'hsl(207, 25%, 11%, 0.4)',
  'neutral-light-40': 'hsl(207, 25%, 85%, 0.4)',
  'purple-dark-40': 'hsl(247, 100%, 62%, 0.4)',
  'purple-light-40': 'hsl(247, 100%, 80%, 0.4)',
  'teal-dark-40': 'hsl(188, 100%, 28%, 0.4)',
  'teal-light-40': 'hsl(188, 35%, 55%, 0.4)',
  'orange-dark-40': 'hsl(20, 100%, 50%, 0.4)',
  'orange-light-40': 'hsl(15, 90%, 65%, 0.4)',
  'red-dark-40': 'hsl(1, 65%, 54%, 0.4)',
  'red-light-40': 'hsl(1, 100%, 70%, 0.4)',
  'yellow-dark-40': 'hsl(35, 100%, 38%, 0.4)',
  'yellow-light-40': 'hsl(35, 100%, 55%, 0.4)',
  'green-dark-40': 'hsl(165, 100%, 26%, 0.4)',
  'green-light-40': 'hsl(165, 100%, 37%, 0.4)',
  'blue-dark-40': 'hsl(207, 100%, 42%, 0.4)',
  'blue-light-40': 'hsl(207, 100%, 58%, 0.4)',
  'white-40': 'hsl(0, 0%, 100%, 0.4)',
  'neutral-dark-48': 'hsl(207, 25%, 11%, 0.48)',
  'neutral-light-48': 'hsl(207, 25%, 85%, 0.48)',
  'purple-dark-48': 'hsl(247, 100%, 62%, 0.48)',
  'purple-light-48': 'hsl(247, 100%, 80%, 0.48)',
  'teal-dark-48': 'hsl(188, 100%, 28%, 0.48)',
  'teal-light-48': 'hsl(188, 35%, 55%, 0.48)',
  'orange-dark-48': 'hsl(20, 100%, 50%, 0.48)',
  'orange-light-48': 'hsl(15, 90%, 65%, 0.48)',
  'red-dark-48': 'hsl(1, 65%, 54%, 0.48)',
  'red-light-48': 'hsl(1, 100%, 70%, 0.48)',
  'yellow-dark-48': 'hsl(35, 100%, 38%, 0.48)',
  'yellow-light-48': 'hsl(35, 100%, 55%, 0.48)',
  'green-dark-48': 'hsl(165, 100%, 26%, 0.48)',
  'green-light-48': 'hsl(165, 100%, 37%, 0.48)',
  'blue-dark-48': 'hsl(207, 100%, 42%, 0.48)',
  'blue-light-48': 'hsl(207, 100%, 58%, 0.48)',
  'white-48': 'hsl(0, 0%, 100%, 0.48)',
  'neutral-dark-56': 'hsl(207, 25%, 11%, 0.56)',
  'neutral-light-56': 'hsl(207, 25%, 85%, 0.56)',
  'purple-dark-56': 'hsl(247, 100%, 62%, 0.56)',
  'purple-light-56': 'hsl(247, 100%, 80%, 0.56)',
  'teal-dark-56': 'hsl(188, 100%, 28%, 0.56)',
  'teal-light-56': 'hsl(188, 35%, 55%, 0.56)',
  'orange-dark-56': 'hsl(20, 100%, 50%, 0.56)',
  'orange-light-56': 'hsl(15, 90%, 65%, 0.56)',
  'red-dark-56': 'hsl(1, 65%, 54%, 0.56)',
  'red-light-56': 'hsl(1, 100%, 70%, 0.56)',
  'yellow-dark-56': 'hsl(35, 100%, 38%, 0.56)',
  'yellow-light-56': 'hsl(35, 100%, 55%, 0.56)',
  'green-dark-56': 'hsl(165, 100%, 26%, 0.56)',
  'green-light-56': 'hsl(165, 100%, 37%, 0.56)',
  'blue-dark-56': 'hsl(207, 100%, 42%, 0.56)',
  'blue-light-56': 'hsl(207, 100%, 58%, 0.56)',
  'white-56': 'hsl(0, 0%, 100%, 0.56)',
  'neutral-dark-64': 'hsl(207, 25%, 11%, 0.64)',
  'neutral-light-64': 'hsl(207, 25%, 85%, 0.64)',
  'purple-dark-64': 'hsl(247, 100%, 62%, 0.64)',
  'purple-light-64': 'hsl(247, 100%, 80%, 0.64)',
  'teal-dark-64': 'hsl(188, 100%, 28%, 0.64)',
  'teal-light-64': 'hsl(188, 35%, 55%, 0.64)',
  'orange-dark-64': 'hsl(20, 100%, 50%, 0.64)',
  'orange-light-64': 'hsl(15, 90%, 65%, 0.64)',
  'red-dark-64': 'hsl(1, 65%, 54%, 0.64)',
  'red-light-64': 'hsl(1, 100%, 70%, 0.64)',
  'yellow-dark-64': 'hsl(35, 100%, 38%, 0.64)',
  'yellow-light-64': 'hsl(35, 100%, 55%, 0.64)',
  'green-dark-64': 'hsl(165, 100%, 26%, 0.64)',
  'green-light-64': 'hsl(165, 100%, 37%, 0.64)',
  'blue-dark-64': 'hsl(207, 100%, 42%, 0.64)',
  'blue-light-64': 'hsl(207, 100%, 58%, 0.64)',
  'white-64': 'hsl(0, 0%, 100%, 0.64)',
  'neutral-dark-72': 'hsl(207, 25%, 11%, 0.72)',
  'neutral-light-72': 'hsl(207, 25%, 85%, 0.72)',
  'purple-dark-72': 'hsl(247, 100%, 62%, 0.72)',
  'purple-light-72': 'hsl(247, 100%, 80%, 0.72)',
  'teal-dark-72': 'hsl(188, 100%, 28%, 0.72)',
  'teal-light-72': 'hsl(188, 35%, 55%, 0.72)',
  'orange-dark-72': 'hsl(20, 100%, 50%, 0.72)',
  'orange-light-72': 'hsl(15, 90%, 65%, 0.72)',
  'red-dark-72': 'hsl(1, 65%, 54%, 0.72)',
  'red-light-72': 'hsl(1, 100%, 70%, 0.72)',
  'yellow-dark-72': 'hsl(35, 100%, 38%, 0.72)',
  'yellow-light-72': 'hsl(35, 100%, 55%, 0.72)',
  'green-dark-72': 'hsl(165, 100%, 26%, 0.72)',
  'green-light-72': 'hsl(165, 100%, 37%, 0.72)',
  'blue-dark-72': 'hsl(207, 100%, 42%, 0.72)',
  'blue-light-72': 'hsl(207, 100%, 58%, 0.72)',
  'white-72': 'hsl(0, 0%, 100%, 0.72)',
  'neutral-dark-80': 'hsl(207, 25%, 11%, 0.8)',
  'neutral-light-80': 'hsl(207, 25%, 85%, 0.8)',
  'purple-dark-80': 'hsl(247, 100%, 62%, 0.8)',
  'purple-light-80': 'hsl(247, 100%, 80%, 0.8)',
  'teal-dark-80': 'hsl(188, 100%, 28%, 0.8)',
  'teal-light-80': 'hsl(188, 35%, 55%, 0.8)',
  'orange-dark-80': 'hsl(20, 100%, 50%, 0.8)',
  'orange-light-80': 'hsl(15, 90%, 65%, 0.8)',
  'red-dark-80': 'hsl(1, 65%, 54%, 0.8)',
  'red-light-80': 'hsl(1, 100%, 70%, 0.8)',
  'yellow-dark-80': 'hsl(35, 100%, 38%, 0.8)',
  'yellow-light-80': 'hsl(35, 100%, 55%, 0.8)',
  'green-dark-80': 'hsl(165, 100%, 26%, 0.8)',
  'green-light-80': 'hsl(165, 100%, 37%, 0.8)',
  'blue-dark-80': 'hsl(207, 100%, 42%, 0.8)',
  'blue-light-80': 'hsl(207, 100%, 58%, 0.8)',
  'white-80': 'hsl(0, 0%, 100%, 0.8)',
  'neutral-dark-100': 'hsl(207, 25%, 11%, 1)',
  'neutral-light-100': 'hsl(207, 25%, 85%, 1)',
  'purple-dark-100': 'hsl(247, 100%, 62%, 1)',
  'purple-light-100': 'hsl(247, 100%, 80%, 1)',
  'teal-dark-100': 'hsl(188, 100%, 28%, 1)',
  'teal-light-100': 'hsl(188, 35%, 55%, 1)',
  'orange-dark-100': 'hsl(20, 100%, 50%, 1)',
  'orange-light-100': 'hsl(15, 90%, 65%, 1)',
  'red-dark-100': 'hsl(1, 65%, 54%, 1)',
  'red-light-100': 'hsl(1, 100%, 70%, 1)',
  'yellow-dark-100': 'hsl(35, 100%, 38%, 1)',
  'yellow-light-100': 'hsl(35, 100%, 55%, 1)',
  'green-dark-100': 'hsl(165, 100%, 26%, 1)',
  'green-light-100': 'hsl(165, 100%, 37%, 1)',
  'blue-dark-100': 'hsl(207, 100%, 42%, 1)',
  'blue-light-100': 'hsl(207, 100%, 58%, 1)',
  'white-100': 'hsl(0, 0%, 100%, 1)',
}
